import { observer } from "mobx-react-lite";

import { useStores } from "@stores";

import { usePublicSubscriptions } from "@src/api/ws/public-subscriptions";

export const OrderbookAndTradesStoreLoader = observer(() => {
  const { marketStore } = useStores();
  usePublicSubscriptions(marketStore.activeMarket?.symbol);

  return null;
});
